import { Text } from 'react-native';

export const CartContent = () => {
  return (
    <Text style={{ fontSize: 20, fontWeight: 'bold', alignSelf: 'center', marginTop: 10 }}>
      Work in progress
    </Text>
  );
};
